<div class="modal-header border-0 pb-0">
    <button type="button" class="btn-close ms-auto" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body pt-0 px-4 pb-4">
    <div class="text-center mb-4">
        <img class="mb-3" src="assets/img/logo.svg" alt="Cbb Store" [width]="60">
        <h4 class="modal-title text-uppercase fw-bold">
            Escoge tu producto
        </h4>
        <p class="text-muted mt-2">Selecciona la opcion que mejor se adapte a ti</p>
    </div>
    <div class="row g-3">
        <div class="col-12 col-md-6">
            <button class="btn btn-outline-secondary w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-center"
                (click)="selectCatalog()">
                <i class="bi bi-grid-3x3-gap-fill fs-1 mb-3 text-primary"></i>
                <span class="fw-bold">Elegir del catalogo</span>
                <small class="text-muted mt-1">Navega por nuestras categorias</small>
            </button>
        </div>
        <div class="col-12 col-md-6">
            <button class="btn btn-outline-success w-100 h-100 p-4 d-flex flex-column align-items-center justify-content-center"
                (click)="selectKnowProduct()">
                <i class="bi bi-search fs-1 mb-3 text-success"></i>
                <span class="fw-bold">Conozco mi producto</span>
                <small class="text-muted mt-1">Busca tu producto directamente</small>
            </button>
        </div>
    </div>
</div>
